import { set, get, clone } from "lodash";
import servicesUtils from "../../../utils/servicesUtils";
import { GetPatientsRequest } from "../types";
import { PatientsResponse } from "../../../types/api/Patients";

const getPatients = (
  apiParams: GetPatientsRequest = {},
  prevData?: PatientsResponse | null
): Promise<PatientsResponse> => {
  const prevPage = get(prevData, ["data", "content"], []);
  const prevLastId = get(prevData, ["data", "last_id"], "");
  const { search, pagination_id } = apiParams;

  return new Promise((resolve, reject) => {
    servicesUtils
      .postService<PatientsResponse>("/patients/", apiParams)
      .then((data) => {
        const newData = clone(data);
        let newPage = get(newData, ["data", "content"], []);
        const newLastId = get(newData, ["data", "last_id"], "");
        if (prevLastId !== newLastId || search) {
          if (pagination_id) {
            newPage = [...prevPage, ...newPage];
          }
          set(newData, ["data", "content"], newPage);
        }
        resolve(newData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getPatients;
